export const EDIT_SEARCH_STRING = "EDIT_SEARCH_STRING";
export const START_SEARCH_REQUEST = "START_SEARCH_REQUEST";
export const END_SEARCH_REQUEST = "END_SEARCH_REQUEST";
export const LOAD_SEARCH_RESULTS = "LOAD_SEARCH_RESULTS";
export const INVALID_QUERY_STRING = "INVALID_QUERY_STRING";
export const EMPTY_SEARCH_RESULTS = "EMPTY_SEARCH_RESULTS";
export const LOAD_SINGLE_TRACK = "LOAD_SINGLE_TRACK";
export const LOAD_MISC_SEARCH_RESULTS = "LOAD_MISC_SEARCH_RESULTS";

export const LOAD_COLLECTION_RESULTS = "LOAD_COLLECTION_RESULTS";
export const START_COLLECTION_REQUEST = "START_COLLECTION_REQUEST";
export const END_COLLECTION_REQUEST = "END_COLLECTION_REQUEST";
